<template>
    
    <div class="h-auto">

        <div class="h-6 flex flex-row">

            <div class="h-full w-full flex flex-row justify-center items-center">
            
                <div class="h-8 w-full overflow-hidden flex flex-row">

                    <div class="h-full w-1/6 flex flex-row justify-center items-center bg-white" style="transition: all .3s" :class="{'bg-blue-100': salesperiod == 'yesterday', 'bg-white': salesperiod != 'yesterday'}" @click="updatePeriod('yesterday')">
                        <span class="text-xs text-blue-500" :class="{'font-bold': salesperiod == 'yesterday', 'text-blue-500': salesperiod != 'yesterday'}">Ayer</span>
                    </div>

                    <div class="h-full w-1/6 flex flex-row justify-center items-center bg-white" style="transition: all .3s" :class="{'bg-blue-100': salesperiod == 'today', 'bg-white': salesperiod != 'today'}" @click="updatePeriod('today')">
                        <span class="text-xs text-blue-500" :class="{'font-bold': salesperiod == 'today', 'text-blue-500': salesperiod != 'today'}">Hoy</span>
                    </div>

                    <div class="h-full w-1/6 flex flex-row justify-center items-center bg-white" style="transition: all .3s" :class="{'bg-blue-100': salesperiod == 'week', 'bg-white': salesperiod != 'week'}" @click="updatePeriod('week')">
                        <span class="text-xs text-blue-500" :class="{'font-bold': salesperiod == 'week', 'text-blue-500': salesperiod != 'week'}">Semana</span>
                    </div>

                    <div class="h-full w-1/6 flex flex-row justify-center items-center bg-white" style="transition: all .3s" :class="{'bg-blue-100': salesperiod == 'month', 'bg-white': salesperiod != 'month'}" @click="updatePeriod('month')">
                        <span class="text-xs text-blue-500" :class="{'font-bold': salesperiod == 'month', 'text-blue-500': salesperiod != 'month'}">Mes</span>
                    </div>

                    <div class="h-full w-1/6 flex flex-row justify-center items-center bg-white" style="transition: all .3s" :class="{'bg-blue-100': salesperiod == 'year', 'bg-white': salesperiod != 'year'}" @click="updatePeriod('year')">
                        <span class="text-xs text-blue-500" :class="{'font-bold': salesperiod == 'year', 'text-blue-500': salesperiod != 'year'}">Año</span>
                    </div>

                    <div class="h-full w-1/6 flex flex-row justify-center items-center bg-white" style="transition: all .3s" :class="{'bg-blue-100': salesperiod == 'custom', 'bg-white': salesperiod != 'custom'}" @click="updatePeriod('custom')">
                        <i class="mdi mdi-calendar text-blue-500" :class="{'font-bold': salesperiod == 'custom', 'text-blue-500': salesperiod != 'custom'}"></i>
                    </div>

                </div>
            
            </div>

        </div>

        <div class="w-full overflow-hidden bg-blue-100 flex flex-row justify-center items-center" :class="{'h-0': salesperiod != 'custom', 'h-8': salesperiod == 'custom'}" style="transition: all .3s;">
                        
            <v-date-picker v-model="dates" mode='range' :firstDayOfWeek="2" :popover="{ placement: 'bottom', visibility: 'click' }">
                <span class="text-xs text-blue-500" v-if="dates">{{dates.start | moment('DD/MM/YY')}} - {{dates.end | moment("DD/MM/YY")}}</span>
                <span class="text-xs text-blue-500" v-else>Seleeciona una fecha</span>
            </v-date-picker>

        </div>

    </div>

</template>

<script>
import { state,actions } from '../store/store.js';
var moment = require('moment');

export default {
    data(){
        return{
            scrollPosition: null
        }
    },
    methods:{
        updateScroll() {
            this.scrollPosition = window.scrollY
            
        },
        updatePeriod(period){
            if (period != 'custom') {
                state.dates = null;
            }
            actions.setPeriod(period)
        }
    },
    computed:{
        salesperiod(){
            return state.period
        },
        dates:{
            get(){
                return state.dates
            },
            set(value){
                if (state.period == 'custom' && value) {
                    const dates = {
                        start: moment(value.start).format('YYYY-MM-DD'),
                        end: moment(value.end).format('YYYY-MM-DD')
                    };

                    actions.setDates(dates)
                }
            }
        }
    },
    watch:{
        salesperiod(n,o){
        },
        scrollPosition(n,o){
            
            if(n<250){
                actions.setShowMenu(false)
            }
            if(n>250){
                actions.setShowMenu(true)
            }
        }
    },
    mounted(){
        window.addEventListener('scroll', this.updateScroll);
    }
}
</script>